var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tracks"},_vm._l((_vm.tracks),function(track){return _c('Track',{key:track.channel,attrs:{"track":track}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }